export enum RequestTypeEnum {
    PUBLIC = 'PUBLIC',
    AUTHENTICATED = 'AUTHENTICATED',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
}